import { Component, ComponentFactoryResolver, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { DtmService } from 'src/app/services/dtm.service';
import { HeaderContent } from 'src/app/shared/model/headerContent';
import { ShopWindowItem } from 'src/app/shared/model/shop-window-item';
import { ShopWindowManager } from 'src/app/shared/model/shop-window-manager';
import { CatalogService } from 'src/app/shared/services/catalog.service';
import { DiscountModalService } from 'src/app/shared/services/discount-modal.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { ShopWindowService } from 'src/app/shared/services/shop-window.service';
import { SYDLEClientID } from "src/app/shared/constants/one-constants";
import { Dtm, getDtm } from "src/app/shared/enum/dtm";
import { ShopWindow } from 'src/app/shared/model/shop-window';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';

const PRODUCT_CLASSIFICATION = 'saude-do-seu-negocio';

@Component({
    selector: 'pme-sdsn-shop-window',
    templateUrl: './sdsn-shop-window.component.html',
    styleUrls: ['./sdsn-shop-window.component.scss'],
    standalone: false
})

export class SdsnShopWindowComponent {


  //Variáveis de conteúdo do Shop Window
  headerContent: HeaderContent;
  legalNotes: Array<string> = [];
  packages: Array<ShopWindowItem> = [];
  plans: Array<ShopWindowItem> = [];

  // Variáveis de query params
  coupon: any;
  userId: any;
  businessId: any;
  ref: string;
  internalReference: any;
  checksum: any;
  checksumData: { ref: any; internalReference: any; cs: any; };
  isHybridPackage: boolean;

  // Controle do Switch
  hasSelectedPackage: boolean;
  hasSelectedPlan: boolean;
  purchaseOrigin: string;
  submitting: boolean;
  myPlanErrors: Array<string> = [];
  selectedPackage: ShopWindowItem;

  sugestionModalDataProducts: any;
  openModalSuggestionFlag: any;

  stackingOnePackage: boolean;
  stackingOnePlan: boolean;



  constructor(
    public catalogService: CatalogService,
    private discountModalService: DiscountModalService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private shopWindowService: ShopWindowService
  ) {
    this.openDialogSpinner();

    this.clearStorage();

    this.getParameters();



    const validatedMitigation = this.sessionStorageService.getValidatedMitigation();
    this.getProducts(PRODUCT_CLASSIFICATION, validatedMitigation, (items: ShopWindowItem[]) => {
      this.plans = items;
      this.tryCloseDialogSpinner();
    });
  }
  tryCloseDialogSpinner() {
    this.closeDialogSpinner();
    this.dtmService.customLoaded([]);
        this.dtmService.sendPageLoadEvent();
    this.dtmService.productsLoaded(
      this.plans.map((plan) => (
        { 'classificationName': plan.product.classificationName, 'identifier': plan.product.identifier,'totalValue':plan.totalValue}))
    );
    this.dtmService.customLoaded(['ProdImpression', 'OverlayImpression']);
    this.dtmService.ruleChange('ProdImpression');
    this.dtmService.sendPageLoadEvent('ProdImpression');
  }



  getProducts(classification: string, validatedMitigation: any, callback: (items: ShopWindowItem[]) => void): void {
    this.catalogService
      .getProductsByClassification(classification, this.userId, validatedMitigation, this.coupon, this.businessId, this.checksumData
      )
      .subscribe(
        (shopWindow: ShopWindow) => {
          callback(shopWindow.shopWindowItems);
        },
        (error) => {
          throw new Error(
            `Erro ao obter produtos da classificação ${classification}: ${error.message}`,
          );
        },
      );
  }

  clearStorage() {
    this.sessionStorageService.clearSessionStorage(['oneClickPurchase']);
    this.sessionStorageService.clearSessionStorage(['purchaseOrigin']);
    this.sessionStorageService.clearSessionStorage(['oneClickPurchaseData']);
  }

  getParameters() {
    this.getProvisioningParametersFromSessionStorage();

    this.route.queryParams.subscribe((params) => {
      this.coupon = params.coupon;
      if (this.coupon) {
        sessionStorage.setItem('coupon', this.coupon);
      }
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        sessionStorage.setItem('successRedirectUrl', params.redirectUrl);
      }

      // Obtem parametros de checksum
      if (params.cs) {
        if (params.ref) {
          try {
            // Obtem user e business id do parametro ref em base64
            this.ref = atob(params.ref);
            const [refUserId, refBusinessId] = this.ref.split(':');

            if (refUserId) {
              this.userId = refUserId;
            }
            if (refBusinessId) {
              this.businessId = refBusinessId;
            }
            this.setProvisioningParametersOnSessionStorage();
          } catch (err) { }

        }

        if (params.internalReference) {
          this.internalReference = params.internalReference;
        }

        this.checksum = params.cs;
        this.checksumData = {
          ref: this.ref,
          internalReference: this.internalReference,
          cs: this.checksum
        };

        // Remove query params
        this.router.navigate([], {
          queryParams: {
            'cs': null,
            'ref': null,
            'internalReference': null
          },
          queryParamsHandling: 'merge'
        });
      }
    });
  }

  ngOnInit(): void {
    this.loadShopWindowContent();
}

setProvisioningParametersOnSessionStorage() {
  this.sessionStorageService.setUserIdAndBusinessId(
    this.userId,
    this.businessId
  );
  this.dtmService.userLoaded({
    userId: this.userId,
    businessId: this.businessId,
    clientId: SYDLEClientID,
  });

  if (this.userId && this.businessId) {
    this.sessionStorageService.setIsLogged(true);
  }
}

loadShopWindowContent() {
  this.shopWindowService.getShopWindow(PRODUCT_CLASSIFICATION).subscribe((shopWindow: any) => {
    let shopWindowManager = new ShopWindowManager(shopWindow);
    shopWindowManager.legalNotes.forEach(legalNotes => {
      this.legalNotes.push(legalNotes);
    })
    this.headerContent = shopWindowManager.header;
  });
}

getProvisioningParametersFromSessionStorage() {

  this.userId = this.sessionStorageService.getUserId();
  this.businessId = this.sessionStorageService.getBusinessId();
  this.dtmService.userLoaded({
    userId: this.userId,
    businessId: this.businessId,
    clientId: SYDLEClientID,
  });

  if (!this.userId || !this.businessId) {
    this.sessionStorageService.setIsLogged(false);
  } else {
    this.sessionStorageService.setIsLogged(true);
  }
}

openDialogSpinner(): void {
  this.closeDialogSpinner();
  this.dialog.open(LoadingComponent, {
    disableClose: true,
    width: '400px',
    panelClass: 'pme-dialog-loading-panel',
    backdropClass: 'pme-dialog-loading-backdrop'
  });
}

closeDialogSpinner() {
  this.dialog.closeAll();
}


handleProductClick(i: number, autoClicked = false) {

  let currPackages = this.plans;

  let selectedPackage = currPackages[i] ? currPackages[i] : null;

  if (!selectedPackage || selectedPackage?.disable) {
    const enableProducts = currPackages.filter(pckg => !pckg.disable);
    this.openErrorDialog('productDisabled', enableProducts, currPackages[i].product.identifier);
    this.sessionStorageService.setPurchaseOrigin('');
    return;
  }
  if (selectedPackage && selectedPackage.selected && selectedPackage === currPackages[i]) {
    selectedPackage.selected = false;
  }
  this.hasSelectedPackage = this.packages.some(pack => pack.selected === true);
  this.selectedPackage = selectedPackage;

  // Adobe Analytics
  if (!autoClicked) {
    this.discountModalService.setClickedOnPackages(true);
    this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"]);
    this.dtmService.productsLoaded([{
      classificationName: selectedPackage.product.classificationName,
      identifier: selectedPackage.product.identifier,
      value: selectedPackage.totalValue
    }]);
    window.setTimeout(() => '', 500);
    this.dtmService.ruleChange('prodClick');
    this.dtmService.sendPageLoadEvent('prodClick');
  }

}
navigate(i: number) {
  this.submitting = true;
  this.handleProductClick(i);

  // Se existe uma targetURL no sessionStorage, usa-a pra navegar
  const targetUrl = sessionStorage.getItem("targetUrl");
  if (
    targetUrl &&
    targetUrl !== ""
  ) {
    this.router.navigate([targetUrl]);
  } else {
    this.router.navigate(["../identificacao"], { relativeTo: this.route });
  }
  this.sessionStorageService.setProduct(
    this.selectedPackage.product.identifier
  );
  this.sessionStorageService.setClassification(
    this.selectedPackage.product.classificationIdentifier
  );
  this.sessionStorageService.setClassification(
    this.selectedPackage.product.classificationName
  );
}

openErrorDialog(dialogData, enableProducts: ShopWindowItem[], productIdentifier) {
  const data = DialogData.fromPreset(dialogData, { enableProducts });
  const content = data.errorMessage;
  const errorDetail = data.errorDetail;

  this.dialog.open(DialogAlertComponent, {
    disableClose: dialogData === 'checksum' ? true : false,
    panelClass: 'pme-dialog-alert-panel',
    autoFocus: false,
    data: data
  });

  // Analytics
  this.dtmService.customErrorLoaded(['error'], {
    errorDetail: errorDetail || productIdentifier,
    errorMessage: content,
  });
}
errorHandler(error: any): void {
  this.myPlanErrors.push(error);
  this.dtmService.customErrorLoaded(["error"], {
    errorDetail: JSON.stringify(this.myPlanErrors),
    errorMessage:
      "Não foi possível buscar os catálogo de produtos. Tente novamente mais tarde",
  });
}

}
